// datePicker
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import ReactGA from "react-ga"
const charMap = [
  {
    pattern: /\u0660|\u06F0/g,
    replace: "0",
  },
  {
    pattern: /\u0661|\u06F1/g,
    replace: "1",
  },
  {
    pattern: /\u0662|\u06F2/g,
    replace: "2",
  },
  {
    pattern: /\u0663|\u06F3/g,
    replace: "3",
  },
  {
    pattern: /\u0664|\u06F4/g,
    replace: "4",
  },
  {
    pattern: /\u0665|\u06F5/g,
    replace: "5",
  },
  {
    pattern: /\u0666|\u06F6/g,
    replace: "6",
  },
  {
    pattern: /\u0667|\u06F7/g,
    replace: "7",
  },
  {
    pattern: /\u0668|\u06F8/g,
    replace: "8",
  },
  {
    pattern: /\u0669|\u06F9/g,
    replace: "9",
  },
];

function characterPersionToEnglish(text) {
  let temp = text;
  charMap.forEach((value) => {
    temp = temp.replaceAll(value.pattern, value.replace);
  });
  return temp;
}
/*
 * @param {string} timestamp time in seconds
 *@param {string} format the format of time
 *@return {string} the time based on format.
 */
const TimeStampToJalali = (timestamp, format) => {
  let date = new DateObject({
    date: timestamp,
    // calendar: persian,
    // locale: persian_fa,
    // format: format,
  }).convert(persian, persian_fa);
  return date.format(format);
};

const pathMaker = (path) => {
  if (path != undefined) return `https://sabadi.ir/api/${path}`;
  else return path;
};

const translateToProductReactSelect = (arrayValue, reverse) => {
  let after = [];
  if (reverse) {
    // react select to api
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.title = arrayValue[index].label;
      obj.id = arrayValue[index].value;
      after.push(obj);
    }
  } else {
    // api to react select
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.label = arrayValue[index].title;
      obj.value = arrayValue[index].products__id;
      obj.option = JSON.parse(arrayValue[index].available_order_option_ids);
      obj.default_price = arrayValue[index].default_price;
      obj.image = arrayValue[index].path;
      obj.total_inventory_count = arrayValue[index].total_inventory_count;
      obj.default_weight_from = arrayValue[index].default_weight_from;
      obj.default_weight_to = arrayValue[index].default_weight_to;
      obj.main_cover_file_id = arrayValue[index].main_cover_file_id;

      after.push(obj);
    }
  }

  return after;
};
const useAnalyticsEventTracker = (category="Blog category", actionParam, labelParam) => {
  const eventTracker = (action = actionParam, label =labelParam) => {
    ReactGA.event({category, action, label});
  }
  return eventTracker;
}
export {
  TimeStampToJalali,
  pathMaker,
  characterPersionToEnglish,
  translateToProductReactSelect,useAnalyticsEventTracker
};
